
import ReactDOM from 'react-dom';
import { useEffect, useState } from "react";

import {AppLink as Link, AppWrapper, MasterBlocks} from "../components/helpers";
import app from "../components/app";
import Editor from "./editor";
import {convertBlock} from "./blocksLang";
import {languages} from "../components/utility";


const getBlocks = async function(data, lang) {
    app.preloader(true);
    const response = await Promise.all(data.map(function(v){
        return convertBlock(v, lang);
    }));
    app.preloader(false);
    return response;
}
const LandConverter = function({lang,langJson, data, old}) {
    const [status, setStatus] = useState(lang.status); 
    useEffect(() => {
        setStatus(lang.status)
    }, [lang]);
    const saveItem = function(item) {
        console.log(item);
        console.log(old);
        //return false;

        getBlocks(item.data, lang.key).then(function(response){

            app.fetchPost({
                "method":"savePageLang",
                "title":item.title,
                "page":item.page,
                "lang":lang.live,
                "reference":item.id,
                "data":JSON.stringify(response),
                "category":item.category,
                "status":true,
                "default":item.default
            }, false).then(function(response){
                setStatus(true);
                lang["id"] = response.data._id;
            })
        })
       
    }
    const styleSvg = {
        height:"2.5em",
        position: "relative",
        left: "-2px",
        top: "-2px",
        width:"2.5em"
    }

    let loader = "";
    if(status) {
        loader =     <svg xmlns="http://www.w3.org/2000/svg" style={styleSvg} width="16" height="16" fill="currentColor" className="bi bi-check" viewBox="0 0 16 16">
        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
        </svg>

    }
    let preview = "";
    if(status) {
        preview =  <a className="btn btn-outline-secondary btn-sm me-2" href={`/desktop-preview/pages/${lang.id}`}>Preview</a>
    }

    return <li className="list-group-item d-flex align-items-center" style={{height:"50px"}}>
        <div className="border border-2 border-secondary rounded me-2" style={{width:"40px", height:"40px"}}>
            {loader}
        </div>
        <span>{lang.text} ({lang.live})</span>
        <div className="buttons ms-auto">
        <button className="btn btn-outline-secondary btn-sm me-2" onClick={() => saveItem(data)}>Convert</button>
        {preview}
        <a href={`/pages/${lang.id}`} className="btn btn-outline-secondary btn-sm me-2">Edit</a>
        </div>
    </li>
}

export default function Blocks(props) {
    const [data, setData] = useState([]);
    const [item, setItem] = useState(null);
    const [langJson, setLangJson] = useState(languages);
    useEffect(() => {
        if(props.category) {
            app.fetchPost({
                "method":"getAllPages",
                "id":props.category
            }).then(function(response){
                let itemData = response.data[0];
                itemData.data = JSON.parse(itemData.data);
                setItem(itemData);
            })
            loadPages();
        }
    }, []);
    const loadPages = function() {
        app.fetchPost({
            "method":"getAllPages",
            "reference":props.category
        }).then(function(response){
            console.log(response);
            const nextJson = JSON.parse(JSON.stringify(langJson));
            response.data.forEach(function(item){
                nextJson.forEach(function(v){
                    if(v.live === item.lang) {
                        v["status"] = true;
                        v["id"] = item.id;
                        v["data"] = JSON.parse(item.data);
                    }
                })
            })
            console.log(nextJson);
            setLangJson(nextJson);
        })
    }
    if(item) {
        return <AppWrapper>
        <div className="container blocks-container p-2">
            <ul className="list-group">
                {
                    langJson.map(function(v){
                        console.log(v);
                        return <LandConverter key={v.key} lang={v} data={item} old={v.data} id={v.id} already={v.status}  />
                    })
                }
            </ul>
        </div>
    </AppWrapper>
    }
    return <div>Loading</div>
   
}